<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb">
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <grid-row col-spaced>
          <grid-col col-size="3">
            <dashboard-explorer-controls
              class="margin-right-xxl margin-top-l"
              v-model="selectedDay"
              v-on:input="handleSelectedDate"
              v-on:inputFilter="filterChanged"
              :filters="getFilterOptions"
              :filterValue="getFilterOptions[0]"
              :mode="selectedFilter.id === 2 ? 'month' : 'day'"
            />
          </grid-col>
        </grid-row>
        <grid-col col-size="2">

          <health-explorer-controls-group-select
            v-model="selectedGroup"
            :options="groupOptions"
            v-on:click="requestData"
            v-show="groupOptions.length > 1"
            v-on:hidden="hiddeComp"
          />

        </grid-col>
      </div>
    </div>
    <div v-if="showNoGroupsMessage" class="no-groups-message">
      You're not currently part of any corporate group.
    </div>
    <div v-if="aggregateData && selectedFilter.id !== 2">
      <div class="data-container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="3">
            <DataCard :title="$t('health.aggregateData.registeredUsers')" :value="aggregateData.registeredUsers" />
            <DataCard :title="$t('health.aggregateData.kgC02Saving')" :value="aggregateData.co2Savings.toFixed(2)" />
          </grid-col>
        </grid-row>
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="3">
            <DataCard :title="$t('health.aggregateData.activeUsers')" :value="aggregateData.activeUsers" />
            <DataCard :title="$t('health.aggregateData.steps')" :value="aggregateData.steps" />
            <DataCard :title="$t('health.aggregateData.smartphoneCharges')" :value="aggregateData.equivalentPhoneCharges.toFixed(0)" />
          </grid-col>
        </grid-row>
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="3">
            <DataCard :title="$t('health.aggregateData.hoursOfActivity')" :value="(aggregateData.activity/60).toFixed(0)" />
            <DataCard :title="$t('health.aggregateData.kmTravelled')" :value="aggregateData.distanceTraveled.toFixed(2)" />
            <DataCard :title="$t('health.aggregateData.co2ToElectricEnergy')" :value="aggregateData.c02toElectricEnergy.toFixed(2)" />
          </grid-col>
        </grid-row>
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="3">
            <DataCard :title="$t('health.aggregateData.hoursOfSleep')" :value="(aggregateData.sleepTime/60).toFixed(0)" />
            <DataCard :title="$t('health.aggregateData.savedTrees')" :value="aggregateData.savedTress.toFixed(2)" />
          </grid-col>
        </grid-row>
      </div>
    </div>
    <div v-else-if="error">
      <p>Error fetching data: {{ error.message }}</p>
    </div>
    <div v-if="selectedFilter.id === 2">
      <div class="flex flex-direction-variable margin-top-xxl">

        <div class="max-width">
          <dashboard-chart
            :data="stepsData"
            :cumulative="true"
            :format-scale="true"
            title="health.aggregateData.stepsTrend"
            y-label="Pasos"
            color="#ff7c00"
          />
        </div>

        <div class="max-width">
          <dashboard-chart
            :data="activityData"
            :cumulative="true"
            :format-scale="true"
            title="health.aggregateData.activityTrend"
            y-label="Minutos"
            color="#ff7c00"
          />
        </div>
      </div>

      <div class="flex flex-direction-variable margin-top-xxl">
        <div class="max-width">
          <dashboard-chart
            :data="sleepData"
            :cumulative="false"
            :format-scale="false"
            title="health.aggregateData.sleepTrend"
            y-label="Horas"
            color="#ff8383"
            chart-type="bar"
          />
        </div>
      </div>
    </div>

  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import aggregateDataApi from 'BRAND/api/dashboard';
import DataCard from 'BRAND/components/aggregate/DataCard.vue';
import GridCol from '@/components/shared/grid/GridCol.vue';
import GridRow from '@/components/shared/grid/GridRow.vue';
import ControlsBar from '@/components/shared/ControlsBar.vue';
import DashboardExplorerControls from '../components/explorer/DashboardExplorerControls.vue';
import HealthExplorerControlsUserSelect from '../components/explorer/HealthExplorerControlsUserSelect.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
import HealthExplorerControlsGroupSelect from '../components/explorer/HealthExplorerControlsGroupSelect.vue';
import VueC3 from 'vue-c3';
import DashboardChart from 'BRAND/components/summary/DashboardChart.vue';

export default {
  name: 'Dashboard',
  components: {
    VueC3,
    HealthExplorerControlsGroupSelect,
    HealthExplorerControlsUserSelect,
    DashboardExplorerControls,
    ControlsBar,
    GridRow,
    GridCol,
    DataCard,
    MainLayout,
    VueDatepickerLocal,
    DashboardChart
  },
  props: {
    hasSettings: {
      type: Boolean,
      default: false
    },
    hasControlsBar: {
      type: Boolean,
      default: true
    },
    controlsBg: {
      type: String,
      default: 'dark'
    },
    hasFilterLeft: {
      type: Boolean,
      default: false
    },
    hasFilterRight: {
      type: Boolean,
      default: false
    },
    breadcrumb: {
      type: Array,
      default: () => []
    },
    filterStartDateLeft: {
      type: String,
      default: ''
    },
    filterStartDateRight: {
      type: String,
      default: ''
    },
    filterDateIdLeft: {
      type: String,
      default: ''
    },
    filterDateIdRight: {
      type: String,
      default: ''
    },
    filterTitleLeft: {
      type: String,
      default: ''
    },
    filterTitleRight: {
      type: String,
      default: ''
    },
    filterModeSelected: {
      type: String,
      default: ''
    },
    filterModeTitle: {
      type: String,
      default: ''
    },
    customControls: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false;
      }
    },
    showPoweredBy: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      aggregateData: null,
      error: null,
      startDate: null,
      endDate: null,
      selectedDay: new Date(),
      selectedGroup: null,
      groupOptions: [],
      disableGroupSelect: false,
      selectedFilter: {id: 1},
      aggregateChartData: null,
      showNoGroupsMessage: false,
      sleepData: [],
      stepsData: [],
      activityData: [],
      distanceData: []
    };
  },
  mounted () {
  },
  watch: {
    selectedGroup (newVal, oldVal) {
      // eslint-disable-next-line no-console
      console.log('selectedGroup changed:', oldVal, '->', newVal, new Error().stack);
    }
  },
  created () {
    const today = new Date();
    aggregateDataApi.getGroups(this)
      .then(data => {
        this.groupOptions = data.map(group => ({
          id: group.id,
          label: group.label
        }));

        if (this.groupOptions.length === 0) {
          this.showNoGroupsMessage = true;
          return;
        }

        this.showNoGroupsMessage = false;

        if (!this.selectedGroup) {
          this.selectedGroup = this.groupOptions[0].id;
        }

        if (this.groupOptions.length === 1) {
          this.$emit('hidden');
        }

        this.handleSelectedDate(today);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log('Error fetching groups:', error);
      });
  },
  methods: {
    handleSelectedDate (selectedDate) {
      this.selectedDay = selectedDate;

      if (this.selectedFilter && this.selectedFilter.id === 1) { // Day view
        // Calculate startDate and endDate for the selected day
        this.startDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0));
        this.endDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 23, 59, 59));
      } else if (this.selectedFilter && this.selectedFilter.id === 2) { // Month view
        // Calculate startDate and endDate for the selected month
        const year = selectedDate.getFullYear();
        const month = selectedDate.getMonth();
        this.startDate = new Date(Date.UTC(year, month, 1, 0, 0, 0)); // First day of the month
        this.endDate = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59)); // Last day of the month
      } else {
        // Default to day view
        const startDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0));
        const endDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 23, 59, 59));

        this.startDate = startDate;
        this.endDate = endDate;
      }

      const startDateString = this.startDate.toISOString().slice(0, 10);
      const endDateString = this.endDate.toISOString().slice(0, 10);
      this.startDate = startDateString;
      this.endDate = endDateString;

      this.requestData();
    },
    requestData () {
      if (!this.selectedGroup) {
        return;
      }

      // eslint-disable-next-line no-console
      console.log('requestData called with:', {
        selectedGroup: this.selectedGroup,
        startDate: this.startDate,
        endDate: this.endDate,
        selectedFilter: this.selectedFilter
      });

      aggregateDataApi.getAggregateData(this, this.selectedGroup, this.startDate, this.endDate)
        .then((data) => {
          this.aggregateData = data;
        });

      aggregateDataApi.getCorporateData(this, this.selectedGroup, this.startDate, this.endDate)
        .then(corporateData => {
          corporateData.sort((a, b) => new Date(a.date) - new Date(b.date));
          this.sleepData = corporateData.map(item => item.sleepTime);
          this.stepsData = corporateData.map(item => item.steps);
          this.activityData = corporateData.map(item => item.activity);
          this.distanceData = 0;
        });
    },
    requestDataInEmit () {
      if (this.disableGroupSelect) {
        this.requestData();
      }
    },
    filterChanged (selectValue) {
      this.selectedFilter = selectValue;
      this.handleSelectedDate(this.selectedDay);
    },
    hiddeComp () {
      this.disableGroupSelect = !this.disableGroupSelect;
    }
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('menu.workspace'),
          link: '/workspace'
        },
        {
          name: this.$t('menu.dashboard'),
          link: '/dashboard',
          disabled: true
        }
      ];
    },
    getFilterOptions () {
      let reObj = [
        {label: this.$t('health.explorer.controlsDay'), id: 1},
        {label: this.$t('health.explorer.controls30Simple'), id: 2}
      ];
      return reObj;
    }
  }
};

</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.data-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.row {
  display: flex;
  margin-bottom: 20px;
}

.chart-title {
  display: flex;
  font-size: 1.2rem;
  margin-top: 15px;
  margin-bottom: -25px;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.flex {
  display: flex;
}

.flex-direction-variable {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  @media (min-width: $screen-wide) {
    flex-direction: row;
    gap: 32px;
  }
}

.max-width {
  width: 100%;
  flex: 1 1 48%; // two per row on desktop
}

.margin-top-xxl {
  margin-top: $sp-margin;
}

.sleep-monthly-summary,
.vue-c3 {
  width: 100%;
  height: 250px;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/Dashboard.vue